<div class="grid p-fluid">
    <div class="col-12">
        <p-dropdown [options]="sections"
            [(ngModel)] = "sectionSelect">
            <ng-template pTemplate="selectedItem">
              <div class="item" class="flex align-items-center">
                  <div class="flex align-items-center">{{ sectionSelect.Title }}</div>
              </div>
            </ng-template>
            <ng-template let-section pTemplate="item">
                <div class="item">
                    <div>{{section.Title}}</div>
                </div>
            </ng-template>
        </p-dropdown>
    </div>
    <div class="col-12">
        <p-accordion (click)="accordionAction()"  *ngIf="sectionSelect!==undefined">
            <p-accordionTab *ngFor="let subsection of sectionSelect.ListSubSections;">
                <ng-template pTemplate="header" class="grid">
                        <div class="col-6 py-0"><span class="font-bold white-space-nowrap">{{subsection.Title}}</span></div>
                </ng-template>
                <app-helper-subsection [subsection]="subsection" [controller]="false" [mobile]="mobile"></app-helper-subsection>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>
